(ns practitest.frontend.common.rules-engine
  (:require
    [practitest.frontend.common-entities.metadata :as metadata]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]))

(re-frame/reg-event-db
  ::update-field-state-rules
  (fn [db [_ field-id value]]
    (let [current-entity (:current-entity db)
          entity-metadata (get metadata/entities-metadata current-entity)
          form-id (:form-id entity-metadata)]
      (update-in db [:form-states2 form-id :fields field-id]
                 (fn [field]
                   (-> field
                       (assoc :value value)
                       (assoc :dirty? true)))))))

(defn- set-field-value-rules
  [element new-value]
  (let [id-key (keyword (.-id element))]
    (re-frame/dispatch [::update-field-state-rules id-key new-value])))

(defn find-first [selectors]
  (some (fn [sel] (.querySelector js/document sel)) selectors))

(defn wait-for-elements
  [selectors init-fn attach-fn entity-key]
  (let [check-and-init!
        (fn []
          (when (and
                  (= @(re-frame/subscribe [::subs/current-entity]) entity-key)
                  (every? find-first selectors))
            (init-fn)
            (attach-fn)
            true))]
    ;; run immediately in case elements are already present
    (when-not (check-and-init!)
      ;; otherwise observe for future DOM mutations
      (let [observer
            (js/MutationObserver.
              (fn [_mutations _obs]
                (when (check-and-init!)
                  (.disconnect _obs))))]
        (.observe observer js/document #js {:childList true :subtree true})))))

;; Rule 1: show/hide “leapwork flow” fields when automation checkbox toggles, only on :test
(def class-automation-checkbox-val
  [".rules_engine_cf_71927_val"
   ".rules_engine_cf_71243_val"
   ".rules_engine_cf_71219_val"
   ".rules_engine_cf_70849_val"])

(def class-leapwork-flow-name-all
  [".rules_engine_cf_72763_all"
   ".rules_engine_cf_72845_all"
   ".rules_engine_cf_72846_all"
   ".rules_engine_cf_72847_all"])

(def class-leapwork-flow-id-all
  [".rules_engine_cf_71294_all"
   ".rules_engine_cf_71240_all"
   ".rules_engine_cf_71216_all"
   ".rules_engine_cf_70857_all"])

(defn update-fields-visibility []
  (js/setTimeout
    (fn []
      (let [checkbox (find-first class-automation-checkbox-val)
            target-div (find-first class-leapwork-flow-id-all)
            target-div-2 (find-first class-leapwork-flow-name-all)]
        (when (and checkbox target-div target-div-2)
          (let [is-checked (.-checked checkbox)]
            (set! (.-style.display target-div) (if is-checked "flex" "none"))
            (set! (.-style.display target-div-2) (if is-checked "flex" "none"))))))
    300))

(defn attach-listener-on-checkbox-mutation []
  (when-let [checkbox (find-first class-automation-checkbox-val)]
    (.addEventListener checkbox "input" (fn [_] (update-fields-visibility)))))

;; initialize rule 1 when entity is :test
(wait-for-elements
  [class-automation-checkbox-val class-leapwork-flow-id-all class-leapwork-flow-name-all]
  update-fields-visibility
  attach-listener-on-checkbox-mutation
  :test)



;; Rule 2: set URL field when JIRA status changes, only on :requirement
(def class-jira-status-val
  [".rules_engine_sf_334834_val"
   ".rules_engine_sf_334651_val"
   ".rules_engine_sf_334619_val"
   ".rules_engine_sf_333467_val"])

(def class-url-val
  [".rules_engine_cf_72792_val"
   ".rules_engine_cf_72793_val"
   ".rules_engine_cf_72794_val"
   ".rules_engine_cf_72795_val"])

(def mapped-status-url
  {"Merged to Develop"   "https://ofbiztest-staging.stannah.co.uk/"
   "Test on OAT"         "https://pwa.oat.qop.stannah.cloud/"
   "Test on SIT"         "https://pwa.sit.qop.stannah.cloud/"
   "Code review complete" "Docker"})

(defn update-url-by-jira-status []
  (let [status-field (find-first class-jira-status-val)
        url-field    (find-first class-url-val)]
    (when (and status-field url-field)
      (let [new-url (get mapped-status-url (.-textContent status-field) "")
            old-url (.-value url-field)]
        (when-not (= old-url new-url)
          (set-field-value-rules url-field new-url))))))

(defn attach-listener-on-status-mutation []
  (when-let [status-field (find-first class-jira-status-val)]
    (.addEventListener status-field "input" (fn [_] (update-url-by-jira-status)))))

;; initialize rule 2 when entity is :requirement
(wait-for-elements
  [class-jira-status-val class-url-val]
  update-url-by-jira-status
  attach-listener-on-status-mutation
  :requirement)
